module.exports = __webpack_public_path__ + "static/media/let7.2a32cc47.JPG";